module.exports = __webpack_public_path__ + "static/media/Cafeteria.0295e1a5.glb";